import { createSvgIcon } from "@mui/material";

export const Icon = createSvgIcon(
  <>
    <path d="M8,9.27v-2h9v2H8ZM8,12.27v-2h9v2H8ZM11,22.27h-6c-.83,0-1.54-.29-2.12-.88-.58-.58-.88-1.29-.88-2.12v-3h3V2.27h15v9.03c-.33-.03-.67-.02-1.01.04-.34.06-.67.16-.99.31v-7.38H7v12h6l-2,2H4v1c0,.28.1.52.29.71.19.19.43.29.71.29h6v2ZM13,22.27v-3.08l5.53-5.5c.15-.15.32-.26.5-.32.18-.07.37-.1.55-.1.2,0,.39.04.58.11.18.07.35.19.5.34l.92.93c.13.15.24.32.31.5.08.18.11.37.11.55s-.03.37-.1.56c-.07.19-.18.36-.33.51l-5.5,5.5h-3.07ZM14.5,20.77h.95l3.02-3.05-.45-.48-.48-.45-3.05,3.02v.95ZM18.03,17.25l-.48-.45.92.93-.45-.48Z" />
  </>,
  "InvoiceType",
);

export default Icon;
